import { openNotificationWithIcon as ionicNotification, showToast } from '../../utils/toastManager';

/**
 * Legacy notification function - now uses Ionic Toast
 * @param {string} type - 'success', 'error', 'warning', 'info'
 * @param {string} text - Notification message
 */
export const openNotificationWithIcon = (type, text) => {
  ionicNotification(type, text);
};

/**
 * Modern toast function
 */
export { showToast };
